import { render } from "./ProductBoxSegmentMain.vue?vue&type=template&id=aa469e8a&ts=true"
import script from "./ProductBoxSegmentMain.vue?vue&type=script&lang=ts"
export * from "./ProductBoxSegmentMain.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__